import React from 'react';
import ReactPaginate from 'react-paginate';
import styled from 'styled-components';
import theme from 'themes';
import ArrowSolidRight from 'icons/indexed-icons/ArrowSolidRight';
import ArrowSolidLeft from 'icons/indexed-icons/ArrowSolidLeft';
interface Props {
  numItems?: number;
  itemsPerPage?: number;
  pageRangeDisplayed?: number;
  onPageChange: (page: number) => void;
  forcePage?: number;
  currentPage?: number;
}
interface LabelProps {
  pageCount?: number;
  currentPage: number;
}
const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledPagination = styled(ReactPaginate)`
  color: ${({ theme }) => theme.colors.lightGrey8};
  display: flex;
  list-style: none;
  padding: 0;
  margin: 1rem 0;

  li {
    display: flex;
    align-items: center;
    &.previous a,
    &.next a {
      line-height: 19px;
    }
    a {
      padding: 0 0.5rem;
      cursor: pointer;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.lightGrey8};
    }
    &.selected {
      a {
        color: ${({ theme }) => theme.colors.primaryBlue5};
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
`;

const PreviousLabel = ({ currentPage }: LabelProps): JSX.Element => {
  return currentPage === 0 ? (
    <span style={{ cursor: 'not-allowed' }}>
      <ArrowSolidLeft color={theme.colors.lightGrey3} />
    </span>
  ) : (
    <ArrowSolidLeft />
  );
};
const NextLabel = ({ currentPage, pageCount }: LabelProps) => {
  return currentPage + 1 === pageCount ? (
    <span style={{ cursor: 'not-allowed' }}>
      <ArrowSolidRight color={theme.colors.lightGrey3} />
    </span>
  ) : (
    <ArrowSolidRight />
  );
};

const Pagination = ({
  onPageChange,
  pageRangeDisplayed = 5,
  numItems,
  itemsPerPage,
  forcePage,
  currentPage
}: Props): JSX.Element | null => {
  const pageCount = numItems && itemsPerPage ? Math.ceil(numItems / itemsPerPage) : 0;
  if (!pageCount || pageCount === 1) {
    return null;
  }

  return (
    <Container>
      <StyledPagination
        marginPagesDisplayed={1}
        pageRangeDisplayed={pageRangeDisplayed}
        pageCount={pageCount}
        previousLabel={<PreviousLabel currentPage={currentPage as number} />}
        nextLabel={<NextLabel currentPage={currentPage as number} pageCount={pageCount} />}
        onPageChange={({ selected }: { selected: number }) => onPageChange(selected)}
        forcePage={forcePage}
      />
    </Container>
  );
};

export default Pagination;
